import React from 'react';
import { useParams } from 'react-router-dom';

const PlaceholderPage: React.FC = () => {
  const { gtin } = useParams<{ gtin: string }>();

  return (
    <div className="container">
      <div className="card text-center">
        <h1 className="card-title">Digital Product Passport Coming Soon</h1>
        <p className="text-muted">
          Product information for GTIN <code>{gtin || 'unknown'}</code> is being prepared.
        </p>
        <p className="text-muted">
          The QR code on this product is permanent — passport data will appear here when published.
        </p>
      </div>
    </div>
  );
};

export default PlaceholderPage;
